"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolTip = void 0;

var tslib_1 = require("tslib");

var react_dom_1 = require("@floating-ui/react-dom");

var ui_flex_1 = require("@hopin-team/ui-flex");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_icon_1 = require("@hopin-team/ui-icon");

var polished_1 = require("polished");

var react_1 = tslib_1.__importStar(require("react"));

var react_dom_2 = require("react-dom");

var constants_1 = require("./styled/constants");

var content_1 = require("./styled/content");

var element_1 = require("./styled/element");

var pointer_1 = require("./styled/pointer");

var root_1 = require("./styled/root");

var tip_1 = require("./styled/tip");

var trigger_1 = require("./styled/trigger");

var ALIGNMENTS;

(function (ALIGNMENTS) {
  ALIGNMENTS["top"] = "top";
  ALIGNMENTS["right"] = "right";
  ALIGNMENTS["bottom"] = "bottom";
  ALIGNMENTS["left"] = "left";
})(ALIGNMENTS || (ALIGNMENTS = {}));

var defaultAlign = 'top';

var ToolTip = function ToolTip(_a) {
  var _b;

  var _c, _d;

  var __UIScope = _a.__UIScope,
      children = _a.children,
      className = _a.className,
      _e = _a.align,
      align = _e === void 0 ? defaultAlign : _e,
      _f = _a.hidePointer,
      hidePointer = _f === void 0 ? false : _f,
      _g = _a.hideTip,
      hideTip = _g === void 0 ? false : _g,
      icon = _a.icon,
      id = _a.id,
      isInverse = _a.isInverse,
      tip = _a.tip,
      ariaHidden = _a["aria-hidden"],
      _h = _a.type,
      type = _h === void 0 ? 'description' : _h;

  var _j = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'ToolTip',
    className: className,
    __UIScope: __UIScope
  }),
      rootClasses = _j.rootClasses,
      makeClasses = _j.makeClasses;

  var arrowRef = (0, react_1.useRef)(null);

  var _k = (0, react_dom_1.useFloating)({
    whileElementsMounted: function whileElementsMounted(reference, floating, update) {
      return (0, react_dom_1.autoUpdate)(reference, floating, update, {
        animationFrame: true
      });
    },
    placement: align,
    middleware: [(0, react_dom_1.flip)(), (0, react_dom_1.offset)(8), (0, react_dom_1.arrow)({
      element: arrowRef
    })]
  }),
      reference = _k.reference,
      floating = _k.floating,
      x = _k.x,
      y = _k.y,
      strategy = _k.strategy,
      update = _k.update,
      placement = _k.placement,
      middlewareData = _k.middlewareData;

  var arrowCallback = (0, react_1.useCallback)(function (node) {
    arrowRef.current = node;
    update();
  }, [update]);

  var _l = tslib_1.__read((0, react_1.useState)(false), 2),
      showTip = _l[0],
      setShowTip = _l[1];

  var _m = tslib_1.__read((0, react_1.useState)(false), 2),
      entering = _m[0],
      setEntering = _m[1];

  var _o = (_c = middlewareData.arrow) !== null && _c !== void 0 ? _c : {},
      arrowX = _o.x,
      arrowY = _o.y;

  var staticSide = (_d = {
    top: 'bottom',
    right: 'left',
    bottom: 'top',
    left: 'right'
  }[placement.split('-')[0]]) !== null && _d !== void 0 ? _d : defaultAlign;

  var areChildrenDisabled = function areChildrenDisabled() {
    var areDisabled = false;
    react_1.Children.map(children, function (child) {
      if ((0, react_1.isValidElement)(child)) {
        if (child.props.disabled) {
          areDisabled = true;
        }
      }
    });
    return areDisabled;
  };

  var hasTip = typeof tip === 'string' || Array.isArray(tip) && tip.length > 0;
  var triggerElems = react_1.Children.map(children, function (child) {
    if ((0, react_1.isValidElement)(child)) {
      if (child.props.disabled || child.props['aria-disabled'] === 'true') {
        return (0, react_1.cloneElement)(child, {
          style: {
            pointerEvents: 'none'
          }
        });
      }

      if (showTip && hasTip && type === 'label') {
        return (0, react_1.cloneElement)(child, {
          'aria-labelledby': id
        });
      }

      if (showTip && hasTip && type === 'description') {
        return (0, react_1.cloneElement)(child, {
          'aria-describedby': id
        });
      }
    }

    return child;
  });
  (0, react_1.useLayoutEffect)(function () {
    if (!showTip) {
      setEntering(false);
      return;
    }

    var timer = setTimeout(function () {
      return setEntering(true);
    }, 1);
    return function () {
      return clearTimeout(timer);
    };
  }, [showTip]);
  return react_1.default.createElement(root_1.Root, {
    onFocus: function onFocus() {
      return setShowTip(!hideTip);
    },
    onMouseEnter: function onMouseEnter() {
      return setShowTip(!hideTip);
    },
    onBlur: function onBlur() {
      return setShowTip(false);
    },
    onMouseLeave: function onMouseLeave() {
      return setShowTip(false);
    }
  }, react_1.default.createElement(trigger_1.Trigger, {
    ref: reference,
    areChildrenDisabled: areChildrenDisabled()
  }, triggerElems), showTip && hasTip && (0, react_dom_2.createPortal)(react_1.default.createElement(tip_1.Tip, {
    ref: floating,
    role: "tooltip",
    id: id,
    isInverse: isInverse,
    style: {
      left: x !== null && x !== void 0 ? x : 0,
      top: y !== null && y !== void 0 ? y : 0,
      position: strategy
    },
    className: rootClasses,
    "aria-hidden": ariaHidden,
    entering: entering
  }, react_1.default.createElement(pointer_1.Pointer, {
    ref: arrowCallback,
    isInverse: isInverse,
    role: "presentation",
    style: (_b = {
      left: "".concat(arrowX ? arrowX + 'px' : ''),
      top: "".concat(arrowY ? arrowY + 'px' : '')
    }, _b[staticSide] = "-".concat((0, polished_1.rem)(0.5 * constants_1.TAIL_SIZE)), _b.display = hidePointer ? 'none' : undefined, _b)
  }), react_1.default.createElement(content_1.Content, {
    className: makeClasses('Content'),
    color: isInverse ? 'grey-dark' : 'grey-white',
    pattern: "captionMedium",
    px: 2,
    py: 1,
    isInverse: isInverse,
    element: "div"
  }, react_1.default.createElement(ui_flex_1.Flex, {
    alignItems: "center",
    flexDirection: Array.isArray(tip) ? 'column' : undefined
  }, icon && typeof tip === 'string' && react_1.default.createElement(ui_icon_1.Icon, {
    name: icon,
    focusable: "false",
    "aria-hidden": "true",
    title: "".concat(tip, " icon"),
    color: isInverse ? 'grey-dark' : 'grey-white',
    mr: 1
  }), typeof tip === 'string' ? tip : tip === null || tip === void 0 ? void 0 : tip.map(function (tipElement, index) {
    return react_1.default.createElement(element_1.Element, {
      key: index
    }, tipElement);
  })))), document.body));
};

exports.ToolTip = ToolTip;